/* tslint:disable */
/* eslint-disable */
/**
 * 
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { ControlPPPLoansScan } from './ControlPPPLoansScan';
import {
    ControlPPPLoansScanFromJSON,
    ControlPPPLoansScanFromJSONTyped,
    ControlPPPLoansScanToJSON,
} from './ControlPPPLoansScan';

/**
 * 
 * @export
 * @interface ControlPaginatedPPPLoansScanResponse
 */
export interface ControlPaginatedPPPLoansScanResponse {
    /**
     * 
     * @type {number}
     * @memberof ControlPaginatedPPPLoansScanResponse
     */
    total: number;
    /**
     * 
     * @type {Array<ControlPPPLoansScan>}
     * @memberof ControlPaginatedPPPLoansScanResponse
     */
    results: Array<ControlPPPLoansScan>;
    /**
     * 
     * @type {string}
     * @memberof ControlPaginatedPPPLoansScanResponse
     */
    schema_version: string;
    /**
     * 
     * @type {number}
     * @memberof ControlPaginatedPPPLoansScanResponse
     */
    page: number;
    /**
     * 
     * @type {number}
     * @memberof ControlPaginatedPPPLoansScanResponse
     */
    page_size: number;
}

/**
 * Check if a given object implements the ControlPaginatedPPPLoansScanResponse interface.
 */
export function instanceOfControlPaginatedPPPLoansScanResponse(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "total" in value;
    isInstance = isInstance && "results" in value;
    isInstance = isInstance && "schema_version" in value;
    isInstance = isInstance && "page" in value;
    isInstance = isInstance && "page_size" in value;

    return isInstance;
}

export function ControlPaginatedPPPLoansScanResponseFromJSON(json: any): ControlPaginatedPPPLoansScanResponse {
    return ControlPaginatedPPPLoansScanResponseFromJSONTyped(json, false);
}

export function ControlPaginatedPPPLoansScanResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): ControlPaginatedPPPLoansScanResponse {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'total': json['total'],
        'results': ((json['results'] as Array<any>).map(ControlPPPLoansScanFromJSON)),
        'schema_version': json['schema_version'],
        'page': json['page'],
        'page_size': json['page_size'],
    };
}

export function ControlPaginatedPPPLoansScanResponseToJSON(value?: ControlPaginatedPPPLoansScanResponse | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'total': value.total,
        'results': ((value.results as Array<any>).map(ControlPPPLoansScanToJSON)),
        'schema_version': value.schema_version,
        'page': value.page,
        'page_size': value.page_size,
    };
}

